// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_BQQqr {
  display : grid;
  grid-template-columns: 1fr 1fr;
  column-gap : var( --size-padMedium, 16px );
  row-gap : var( --size-padMedium, 16px );
  align-items: center;
  justify-items: start;
  justify-content: left;
  width: 80%;
}

.space_Km3nk {
  margin-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/alerts/editor/AlertEditor.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,8BAA8B;EAC9B,0CAA0C;EAC1C,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".grid {\n  display : grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap : var( --size-padMedium, 16px );\n  row-gap : var( --size-padMedium, 16px );\n  align-items: center;\n  justify-items: start;\n  justify-content: left;\n  width: 80%;\n}\n\n.space {\n  margin-bottom: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_BQQqr`,
	"space": `space_Km3nk`
};
export default ___CSS_LOADER_EXPORT___;
